import { EXTERNAL_VECTOR_SOURCE_PREFIX, EXTERNAL_GEOJSON_SOURCE_PREFIX } from './constants';

// these layers are raster at low zooms, and vector at high zooms
export const isHybridLayer = (layer) => !!layer.sourceId;

export const isRasterLayer = (layer) =>
  !!layer.rasterId || (layer.externalSourceType === 'raster' && layer.mappable);

export const isGeoJsonLayer = (layer) => layer.externalSourceType === 'geojson' && layer.mappable;

export const isVectorLayer = (layer) =>
  !isRasterLayer(layer) && !isGeoJsonLayer(layer) && !isHybridLayer(layer) && layer.mappable;

const EXTERNAL_FEATURE_SOURCE_REGEX = new RegExp(
  `^${EXTERNAL_VECTOR_SOURCE_PREFIX}|${EXTERNAL_GEOJSON_SOURCE_PREFIX}`,
);

const EXTERNAL_GEOJSON_SOURCE_REGEX = new RegExp(`^${EXTERNAL_GEOJSON_SOURCE_PREFIX}`);

export const isExternalFeatureSource = (source) => source.match(EXTERNAL_FEATURE_SOURCE_REGEX);
export const isExternalGeoJsonFeatureSource = (source) =>
  source.match(EXTERNAL_GEOJSON_SOURCE_REGEX);
